import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setJwtToken } from '@/helpers/setRequestHeaders'

export interface User {
    
}

export interface UserDto {
    
}

export interface UserAuthorization {
    email: string,
    password: string
}

export interface UserUpdateDto extends UserDto {
    id: number
}

type TUpdateUser = {
    name?: string,
    email?: string,
    phone?: any,
    password?: any,
    company_name?: string,
    company_address?: string,
    company_post?: string
}

export const usersApi = createApi({
    reducerPath: 'usersApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ['USER'],
    endpoints: builder => ({
        registration: builder.mutation<User, UserDto>({
            query: (data) => ({url: "/users", method: "POST", body: data}),
            invalidatesTags: ["USER"]
        }),
        activation: builder.mutation<User, {code: string}>({
            query: (data) => ({url: "/users/activate", method: "POST", body: data}),
            invalidatesTags: ["USER"]
        }),
        login: builder.mutation<{token: string}, UserAuthorization>({
            query: (data) => ({url: "/users/login", method: "POST", body: data}),
            invalidatesTags: ["USER"]
        }),
        userForgotPassword: builder.mutation<any, {email: string}>({
            query: (data) => ({url: "/users/forgot-password", method: "POST", body: data}),
            invalidatesTags: ["USER"]
        }),
        userResetPassword: builder.mutation<any, {hash: string, password: string}>({
            query: (data) => ({url: "/users/refresh-password", method: "POST", body: data}),
            invalidatesTags: ["USER"]
        }),
        getUserData: builder.query<any, {id: number}>({
            query: ({id}) => ({url: `/users/user-detail/${id}`, method: "GET"})
        }),
        updateUserData: builder.mutation<any, TUpdateUser>({
            query: (data) => {return {url: `/users/user-detail`, method: "PATCH", body: {...data}}},
            transformResponse: (res)=>{return res},
            invalidatesTags: ["USER"]
        })
    })
})

export const {
    useActivationMutation,
    useLoginMutation,
    useRegistrationMutation,
    useUserForgotPasswordMutation,
    useUserResetPasswordMutation,
    useGetUserDataQuery,
    useUpdateUserDataMutation
} = usersApi
